import Logo from "./Logo";
import type { LogoAdapterProps } from "./Logo.d";

export { Logo };
export type { LogoAdapterProps };
